module.exports = "<p>\n  redirecting please wait ....\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/admin/admin.component.html
// module id = ../../../../../src/app/components/admin/admin.component.html
// module chunks = main